// extracted by mini-css-extract-plugin
export default {"wrapper":"CompanyCard_wrapper__Xy196","image-container":"CompanyCard_image-container__4vuDB","title":"CompanyCard_title__G9qC4"};